export enum PermissionMessages {
  linkContractToUserText = "permission.linkContractToUserText",
  linkContractsSelectedText = "permission.linkContractsSelectedText",
  permissionsForText = "permission.permissionsForText"
}

export interface TranslationPermissionMessages {
  [PermissionMessages.linkContractToUserText]: string;
  [PermissionMessages.linkContractsSelectedText]: string;
  [PermissionMessages.permissionsForText]: string;
}
